"use strict";
import Peer from "peerjs";

// Singleton pattern
export default class MultiPeer {
  constructor() {
    const vm = this;
    if (vm.constructor.instance) {
      return vm.constructor.instance;
    }

    vm.connections = {};
    vm.peer = new Peer(null, {
      host:  process.env.VUE_APP_PEERJS_TRACKER 
            || (location.host.indexOf('local') !== -1 
                ? 'golf-course.silkwires-dev.com'
                : location.host), 
      port: process.env.VUE_APP_PEERJS_PORT || 9413, 
      secure: true,
      debug: 3, // 0 Prints no logs. 1 Prints only errors. 2 Prints errors and warnings. 3 Prints all logs.
      config: { // increase server to reduce failure <error : "lost connection to server">
        'iceServers': [
          { urls: 'stun:silkwires.com:3478' },
          { 
            urls: 'turn:silkwires.com:3478',
            username: 'wang',
            credential: 'wang123'
          }
        ]
      }
    });
    
    vm.peer.on('disconnected', function (id) {
      console.log('-- Reconnect --');
      vm.peer._id = id;
      vm.peer._lastServerId = id;
      vm.peer.reconnect();
    })
    
    vm.peer.on('error', function(err){
      console.log(err)
    })

    vm.peer.on('connection',function(conn){
      console.log('there is connection incoming from', conn.label)
      return vm.handleConnection(conn, conn.label);
    });

    vm.constructor.instance = this;
  }

  // Start connection with other peer
  connectPeer(remoteId, friendId, myId, sendDataOnOpen = null) {
    const conn = this.peer.connect(remoteId, {label: myId});
    return this.handleConnection(conn, friendId, sendDataOnOpen);
  }
  
  handleConnection(conn, friendId, sendDataOnOpen = null) {
    const _this = this
    conn.on("data", function(data) {
      document.dispatchEvent(new CustomEvent("peerReceiveData", {
        detail: {peer: conn.peer, data}
      }));
    });
    return new Promise(function(resolve, reject) {
      conn.on("open", function(e) {
        if(sendDataOnOpen) {
          console.log('do send message on open')
          conn.send(sendDataOnOpen)
        }
        console.log("Connected with peer: " + conn.peer);
        _this.connections[friendId] = conn;
        resolve(conn)
      })
      _this.peer.on('error', function(err){
        console.log('yes we have some error here')
        reject(err)
      })
      conn.on('error',function(err){
        // handle error
        console.log('something wrong', err);
        document.dispatchEvent(new CustomEvent("peerError", {
          detail: {error: err.message}
        }));
        reject(err)
      });
    })
  }
}
